<template>
    <div>
        <v-card elevation="0">
            <v-card color="#977EBE" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-developer-board</v-icon>
                    &nbsp;ITS Page
                </v-card-title>
            </v-card>
            <v-card-text>
                <Manager />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/ITS/Manager.vue"
export default {
    components: {
        Manager
    }
}
</script>